import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  NavItem,
  NavLink,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { switchToUser } from '../actions/Auth';

const SwitchUserSwitch = ({ originalProfile }) => {
  const intl = useIntl();

  if (!originalProfile) {
    return null;
  }

  return (
    <NavItem>
      <NavLink
        href="#switch-to-user"
        id="switch-to-user-icon"
        onClick={(e) => {
          e.preventDefault();
          switchToUser();
        }}
      >
        <i className="far fa-repeat-alt" />
      </NavLink>
      <UncontrolledTooltip fade={false} placement="bottom" target="switch-to-user-icon">
        {intl.formatMessage({ defaultMessage: 'Switch back to {name}' }, { name: originalProfile.name })}
      </UncontrolledTooltip>
    </NavItem>
  );
};

const mapStateToProps = state => ({
  originalProfile: state.Auth.originalProfile,
});

SwitchUserSwitch.propTypes = {
  originalProfile: PropTypes.object,
};

SwitchUserSwitch.defaultProps = {
  originalProfile: null,
};

export default connect(mapStateToProps)(SwitchUserSwitch);
